import { render, staticRenderFns } from "./SalaryTable.vue?vue&type=template&id=f5931a14&"
import script from "./SalaryTable.vue?vue&type=script&lang=js&"
export * from "./SalaryTable.vue?vue&type=script&lang=js&"
import style0 from "./SalaryTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports